export default {
  select: 'Выбрать метки...'
};
